export default function useDraftsMsg() {
  const messageBar = {}
  const files = {}
  const getSession = () => JSON.parse(sessionStorage.getItem('DraftsMsg')) || {}
  const getSessionFile = () => JSON.parse(sessionStorage.getItem('DraftsMsgFiles')) || {}
  const getActivedMsg = activeKey => {
    Object.assign(messageBar, getSession())
    return messageBar[activeKey] || ''
  }
  const saveActivedMsg = (activeKey, msg) => {
    messageBar[activeKey] = msg
    sessionStorage.setItem('DraftsMsg', JSON.stringify(messageBar))
  }
  // 缓存文件 不传内容就是移除某一项
  const saveFile = (activeKey, filsInfo = []) => {
    files[activeKey] = filsInfo
    sessionStorage.setItem('DraftsMsgFiles', JSON.stringify(files))
  }
  const getFiles = activeKey => {
    if (!activeKey) return []
    const _getSessionFile = getSessionFile()
    Object.assign(files, _getSessionFile)
    return files[activeKey] || []
  }
  return {
    getActivedMsg,
    saveActivedMsg,
    saveFile,
    getFiles
  }
}
